module.exports = __webpack_public_path__ + "static/media/check_512.5a1cccb5.png";